import API from "../apiEndPoint";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addTypeAPI = createAsyncThunk(
  "addType",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.post(
        `/manufacturer/device-type`,
        {
          name: payload?.type,
          note: payload?.note,
        },
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const getTypesAPI = createAsyncThunk(
  "getTypes",
  async (__, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.get(`/manufacturer/device-type`, config);

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

/**
 * updateTypesAPI - Use this for both update and soft-delete
 */
export const updateTypesAPI = createAsyncThunk(
  "updateTypes",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };
      let response = await API.put(
        `/manufacturer/device-type/${payload?.device_type_id}`,
        payload,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const deleteTypesAPI = createAsyncThunk(
  "deleteTypesAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState()?.auth?.token,
        },
      };

      let response = await API.delete(
        `/manufacturer/device-type/${payload.device_type_id}`,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const getModelsAPI = createAsyncThunk(
  "getModels",
  async (__, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.get(`/manufacturer/model`, config);

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const getUnitsAPI = createAsyncThunk(
  "getUnits",
  async (__, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.get(`/manufacturer/measuring-unit`, config);

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const getSellerUnitsAPI = createAsyncThunk(
  "getSellerUnitsAPI",
  async (__, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.get(`/seller/measuring-unit`, config);

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);


export const addModelAPI = createAsyncThunk(
  "addModel",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.post(`/manufacturer/model`, payload, config);

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const addUnitsAPI = createAsyncThunk(
  "addModel",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.post(`/manufacturer/measuring-unit`, payload, config);

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const updateModelsAPI = createAsyncThunk(
  "updateModelsAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };
      let response = await API.put(
        `/manufacturer/model/${payload?.model_id}`,
        payload,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const deleteModelsAPI = createAsyncThunk(
  "deleteModelsAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState()?.auth?.token,
        },
      };

      let response = await API.delete(
        `/manufacturer/model/${payload.model_id}`,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const deleteModelsDataPointsAPI = createAsyncThunk(
  "deleteModelsDataPointsAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState()?.auth?.token,
        },
      };

      let response = await API.delete(
        `/manufacturer/model/${payload?.model_id}/data-point/${payload?.data_point_id}`,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const deviceConfigHistoryAPI = createAsyncThunk(
  "deviceConfigHistoryAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.get(
        `/manufacturer/device/${payload?.device_id}/configuration-history`,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const sellerDeviceConfigHistoryAPI = createAsyncThunk(
  "sellerDeviceConfigHistoryAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };

      let response = await API.get(
        `/seller/device/${payload?.device_id}/configuration-history`,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const deleteDeviceAPI = createAsyncThunk(
  "deleteDeviceAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState()?.auth?.token,
        },
      };

      let response = await API.delete(
        `/manufacturer/device/${payload.device_id}`,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);

export const updateDevicesAPI = createAsyncThunk(
  "updateDevicesAPI",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };
      let response = await API.put(
        `/manufacturer/device/${payload?.device_id}`,
        payload,
        config
      );

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);
export const getAllProducts = createAsyncThunk(
  "getAllProducts",
  async (payload, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };
      let response = await API.get(`/manufacturer/products`, config);

      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);
export const getActiveProduct = createAsyncThunk(
  "getActiveProduct",
  async (payload, { getState }) => {
    console.log(payload, "payloadpayloadpayload");
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState().auth.token,
        },
      };
      let response = await API.get(
        `/manufacturer/products/${payload}/devices`,
        config
      );
      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  }
);
